export default "__VITE_ASSET__e644fc5f__"